import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/data/divergences/page.tsx");
